"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Questionnaire_AnswerOption = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Reference_1 = require("./RTTI_Reference");
exports.RTTI_Questionnaire_AnswerOption = t.recursion('IQuestionnaire_AnswerOption', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        valueInteger: t.number,
        _valueInteger: RTTI_Element_1.RTTI_Element,
        valueDate: t.string,
        _valueDate: RTTI_Element_1.RTTI_Element,
        valueTime: t.string,
        _valueTime: RTTI_Element_1.RTTI_Element,
        valueString: t.string,
        _valueString: RTTI_Element_1.RTTI_Element,
        valueCoding: RTTI_Coding_1.RTTI_Coding,
        valueReference: RTTI_Reference_1.RTTI_Reference,
        initialSelected: t.boolean,
        _initialSelected: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Questionnaire_AnswerOption.js.map